import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import _ from 'lodash';
import { LazyLoadImage } from 'react-lazy-load-image-component';
const DiscountSavingsSection = ({ isSinglecare, pharmacyName, t, i18n }) => {
  let isEs = _.isEqual(i18n.language, 'es');
  return isEs ? (
    <section className="savings">
      <h2>
        {t('How to use your')}
        {isSinglecare
          ? ` para medicamentos SingleCare`
          : ` ${pharmacyName} para medicina`}
      </h2>
      <ul className="steps">
        <li className="step1">
          <div className="stepImg">
            <LazyLoadImage src="/content/images/homepagev2/step1.svg" alt="" />
          </div>
          <h3>1. {t('Compare prices by pharmacy')}</h3>
          <p>
            {isSinglecare
              ? `Busca en ${pharmacyName} ${t(
                  'major pharmacies'
                )} Compara los precios entre medicamentos de patente y
                genéricos, y ve cuánto puedes ahorrar con SingleCare.`
              : `Consulta SingleCare para recetas en ${pharmacyName}
              Compara los precios de medicinas de patente y genéricas y
              cuánto puedes ahorrar con la tarjeta de descuento
              ${pharmacyName} para medicina.`}
          </p>
        </li>
        <li className="step2">
          <div className="stepImg">
            <LazyLoadImage src="/content/images/homepagev2/step2.svg" alt="" />
          </div>
          <h3>2. {t('Get a free coupon card')}</h3>
          <p>
            {isSinglecare
              ? ` Envíate por correo electrónico, mensaje de texto o imprime tu
              tarjeta de descuento para medicamentos ${pharmacyName}
               para obtener precios especiales.`
              : ` Envía un correo, envía un mensaje o imprime tu tarjeta de
              descuento para medicinas en ${pharmacyName} para obtener
              tu precio especial.
`}
          </p>
        </li>
        <li className="step3">
          <div className="stepImg">
            <LazyLoadImage src="/content/images/homepagev2/step3.svg" alt="" />
          </div>
          <h3>3. {t('Save up to 80% today')}</h3>
          <p>
            {isSinglecare
              ? `Simplemente presenta tu tarjeta de descuento para medicamentos
              al farmacéutico en el mostrador y obtén tu descuento.`
              : `Simplemente presenta tu tarjeta de descuento ${pharmacyName}
              para medicina al farmacista en el mostrador para
              obtener tu descuento.`}
          </p>
        </li>
      </ul>
    </section>
  ) : (
    <section className="savings">
      <h2>How to use your {pharmacyName} Prescription Drug Discount Card</h2>
      <ul className="steps">
        <li className="step1">
          <div className="stepImg">
            <LazyLoadImage src="/content/images/homepagev2/step1.svg" alt="" />
          </div>
          <h3>1. Compare prices by pharmacy</h3>
          <p>
            Search SingleCare for prescriptions at
            {!isSinglecare ? ` ${pharmacyName}` : ` major pharmacies`}. Compare
            brand-name and generic drug prices and how much you can save with
            {!isSinglecare
              ? ` ${pharmacyName} prescription drug discount card.`
              : ` SingleCare’s.`}
          </p>
        </li>
        <li className="step2">
          <div className="stepImg">
            <LazyLoadImage src="/content/images/homepagev2/step2.svg" alt="" />
          </div>
          <h3>2. Get a free coupon card</h3>
          <p>
            Email, text, or print your
            {!isSinglecare ? ` ${pharmacyName}` : ` SingleCare`} discount
            prescription card to get your special price.
          </p>
        </li>
        <li className="step3">
          <div className="stepImg">
            <LazyLoadImage src="/content/images/homepagev2/step3.svg" alt="" />
          </div>
          <h3>3. Save up to 80% today</h3>
          <p>
            Simply present your&nbsp;
            {!isSinglecare ? `${pharmacyName}` : `SingleCare`} prescription
            savings card to the pharmacist at the counter and get your discount.
          </p>
        </li>
      </ul>
    </section>
  );
};

DiscountSavingsSection.propTypes = {
  isSinglecare: PropTypes.bool,
  pharmacyName: PropTypes.string
};

DiscountSavingsSection.defaultProps = {
  isSinglecare: true,
  pharmacyName: 'SingleCare'
};

export default withTranslation()(DiscountSavingsSection);
